// a succinct list of all focusable elements can be found here: https://html.spec.whatwg.org/dev/dom.html#interactive-content
// but this list should be fine for our purposes
export const commonFocusableElements = "a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled])," +
  "input[type=\"text\"]:not([disabled]), input[type=\"radio\"]:not([disabled]), " +
  "input[type=\"checkbox\"]:not([disabled]), select:not([disabled]), input[type=\"file\"]:not([disabled])";
  